<template>
	<div class="">
		<chevron-down-icon :class="size" v-if="show"></chevron-down-icon>
		<chevron-up-icon :class="size" v-else-if="mode == 'up'"></chevron-up-icon>
		<chevron-right-icon :class="size" v-else></chevron-right-icon>
	</div>
</template>

<script>
import { ChevronDownIcon, ChevronRightIcon, ChevronUpIcon } from 'vue-feather-icons'
export default {
	name: 'ChevronComponent',
	props: {
		'show': {},
		'mode': {
			type: String,
			default: ''
		},
		'width': {
			type: String,
			default: 'w-4'
		},
		'height': {
			type: String,
			default: 'h-4'
		},
	},
	data () {
		return {

		}
	},
	computed: {
		size() {
			return this.width+' '+this.height;
		}
	},
	components: {
		ChevronDownIcon,
		ChevronRightIcon,
		ChevronUpIcon
	}
}
</script>

<style lang="css" scoped>
</style>
